module.exports = __webpack_public_path__ + "static/media/organizer_12.db80c27e.jpg";